import * as React from 'react';

import StartButton from 'components/StartButton';
import Footer from 'components/Footer';
import Analysing from 'components/Analysing';

import './Result.css';

interface Props {
	message: string;
}

interface analysingState {
	showAnalysing: boolean;
}

class Result extends React.Component<Props, analysingState> {
	constructor(props: Props) {
		super(props);
		this.state = {
			showAnalysing: true,
		};
	}

	handleComplete = () => {
		this.setState({ showAnalysing: false });
	};

	render() {
		return (
			<section className="result">
				<br />
				<StartButton target="/scanner" />
				<br />
				{this.state.showAnalysing ? (
					<Analysing delay={3} onComplete={this.handleComplete} />
				) : (
					<div className="message">{this.props.message}</div>
				)}
				<Footer />
			</section>
		);
	}
}

export default Result;
